import { CaretRight } from '@ui/components/icons';
import { useWalletModal } from '@ui/components/WalletModal/useWalletModal';
import { useIsWrongNetwork } from '@ui/hooks/datachain';
import { Icon } from '@ui/lib/park/ui/icon';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { Box, BoxProps, styled } from 'styled-system/jsx';
import { useAccount } from 'wagmi';

import { ConnectButton } from './WalletConnectButton';

export const RequireConnectionWrapper = ({ children, ...props }: BoxProps) => {
  const { isConnected } = useAccount();
  const isWrongNetwork = useIsWrongNetwork();
  const { t } = useTranslation();
  const { open } = useWalletModal();

  if (isConnected && !isWrongNetwork) {
    return children;
  }

  // not connected
  return (
    <>
      <Wrapper {...props}>
        <ConnectButton
          textStyle="headings.small"
          py={1}
          px={2}
          onClickConnect={() => {
            open();
          }}
        >
          {t('common.Connect Wallet')}
        </ConnectButton>
      </Wrapper>
    </>
  );
};

const Wrapper = styled(Box, {
  base: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
